import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftOneDriveLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 18,
	viewBox: "0 0 28 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10453_52217)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6767 4.99866L10.677 4.99769L16.555 8.53078L20.0575 7.0517C20.7692 6.74293 21.5367 6.5846 22.3121 6.58536C22.4413 6.58536 22.569 6.59125 22.696 6.59975C22.2749 4.95202 21.386 3.4625 20.1372 2.31219C18.8884 1.16188 17.3335 0.400309 15.6615 0.120026C13.9896 -0.160257 12.2724 0.0528132 10.7189 0.733345C9.16527 1.41388 7.84211 2.53257 6.91016 3.95348C6.9401 3.9531 6.96959 3.95122 6.9996 3.95122C8.29867 3.94945 9.57234 4.31226 10.6767 4.99866Z",
				fill: "#0364B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6774 4.99765L10.6771 4.99862C9.57274 4.31222 8.29907 3.94941 7 3.95118C6.96999 3.95118 6.94045 3.95307 6.91055 3.95344C5.63909 3.96924 4.39595 4.33241 3.31473 5.00393C2.2335 5.67546 1.35507 6.62994 0.773824 7.76482C0.19258 8.8997 -0.0695015 10.1721 0.015744 11.4452C0.100989 12.7183 0.530339 13.944 1.25765 14.9907L6.44115 12.8018L8.7454 11.8287L13.876 9.66218L16.5553 8.53074L10.6774 4.99765Z",
				fill: "#0078D4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.6967 6.59935C22.5697 6.59085 22.442 6.58496 22.3128 6.58496C21.5374 6.5842 20.7701 6.74313 20.0584 7.05189L16.5557 8.53038L17.5713 9.14087L20.9007 11.142L22.3532 12.0152L27.32 15.0006C27.7713 14.1599 28.0052 13.2189 28.0002 12.264C27.9953 11.3091 27.7516 10.3707 27.2916 9.53473C26.8315 8.69879 26.1698 7.99203 25.3671 7.4792C24.5643 6.96637 23.6462 6.66384 22.6967 6.59935Z",
				fill: "#1490DF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.3531 12.016L20.9005 11.1429L17.5712 9.14174L16.5555 8.53125L13.8761 9.66269L8.74555 11.8292L6.44131 12.8023L1.25781 14.9912C1.90196 15.9205 2.76067 16.6796 3.76062 17.2036C4.76057 17.7277 5.87205 18.0011 7.00015 18.0005H22.3126C23.3393 18.0008 24.3469 17.7221 25.2285 17.1941C26.1101 16.6661 26.8328 15.9084 27.3199 15.0014L22.3531 12.016Z",
				fill: "#28A8EA"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_10453_52217",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgMicrosoftOneDriveLogo;
